<template>
	<div class="calculate">
		<!-- 步骤条 -->
		<div class="steps">
			<div class="step-content">
				<div
					v-for="(item, index) in items"
					:key="index"
					class="step"
					:style="
						[items.length - 1].includes(index)
							? { flex: 0 }
							: { flex: 1 }
					"
				>
					<div class="box" @click="goStep(index)">
						<img
							:src="
								(finalCurrent - index).toFixed(2) == 0.3
									? item.errorIcon
									: finalCurrent >= index
									? item.finish
									: item.icon
							"
							alt=""
							v-if="clickIndex != index"
						/>
						<img
							v-if="clickIndex == index"
							:src="
								(finalCurrent - index).toFixed(2) == 0.3
									? item.errorIcon
									: item.activeIcon
							"
							alt=""
						/>
						<div
							:class="
								(finalCurrent - index).toFixed(2) == 0.3
									? 'active errorFont'
									: finalCurrent >= index
									? 'active'
									: ''
							"
							:style="{
								fontWeight: [0, 0.3, 0.5].includes(
									toFixed(props.current - index, 1)
								)
									? 600
									: 'unset'
							}"
						>
							{{ item.title }}
						</div>
					</div>

					<!-- 绘制基线 -->
					<div v-if="index != items.length - 1" class="baseLine">
						<!-- 绘制进度线 -->
						<div
							:class="
								index == finalCurrent
									? 'actionLine half'
									: (finalCurrent - index).toFixed(2) == 0.3
									? 'actionLine half error'
									: index < finalCurrent
									? 'actionLine all'
									: ''
							"
						></div>
					</div>
				</div>
			</div>

			<!-- 按钮插槽  -->
			<slot name="action-btn" class="action-btn"></slot>
		</div>

		<div
			class="content beautify_scroll"
			:style="{
				maxHeight: props.hasResult ? 'unset' : 'calc(100vh - 176px)'
			}"
		>
			<div class="left" style="">
				<!-- 侧边栏 -->
				<div v-if="visible" class="side-box beautify_scroll">
					<div class="side-content beautify_scroll">
						<slot name="side"></slot>
					</div>
				</div>
				<div v-if="!visible" class="icon icon2" @click="visibleClick">
					<img src="@/assets/images/unfold.png" alt="" />
				</div>
			</div>
			<div
				:style="{
					borderRadius: visible ? '0 4px 4px 0' : '4px',
					width: visible ? 'calc(100% - 364px)' : '100%'
				}"
				class="right"
			>
				<slot name="content"></slot>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { ref, defineProps, watch, nextTick } from "vue";
	// 引入router
	import { useRouter } from "vue-router";
	const router = useRouter();

	// 引入vuex
	import { useStore } from "vuex";
	const store = useStore();

	// 引入公共方法
	import { toFixed } from "@/plugins/index.js";

	// 引入加密
	import { encryptData } from "@/plugins/index.js";

	const props = defineProps({
		current: {
			type: Number,
			default: () => 0
		},
		hasResult: {
			type: Boolean,
			default: false
		}
	});

	const finalCurrent = ref(0);

	const clickIndex = ref(null);

	// 监听current
	watch(
		() => store.state.projectStep,
		(newVal, oldVal) => {
			finalCurrent.value = newVal;
		},
		{
			immediate: true,
			deep: true
		}
	);
	watch(
		() => props.current,
		(newVal, oldVal) => {
			console.log(newVal);
			console.log(oldVal);
			if (clickIndex.value === null && newVal != 9) {
				clickIndex.value = Math.floor(newVal);
			}
		},
		{
			immediate: true,
			deep: true
		}
	);
	const items = ref([
		{
			title: "负载分析",
			icon: require("@/assets/images/status-icons/step_1.png"),
			activeIcon: require("@/assets/images/status-icons/step_1_active.png"),
			finish: require("@/assets/images/status-icons/step_1_finish.png"),
			errorIcon: require("@/assets/images/status-icons/step_1_error.png")
		},
		{
			title: "配储评估",
			icon: require("@/assets/images/status-icons/step_2.png"),
			activeIcon: require("@/assets/images/status-icons/step_2_active.png"),
			finish: require("@/assets/images/status-icons/step_2_finish.png"),
			errorIcon: require("@/assets/images/status-icons/step_2_error.png")
		},
		{
			title: "经济分析",
			icon: require("@/assets/images/status-icons/step_3.png"),
			activeIcon: require("@/assets/images/status-icons/step_3_active.png"),
			finish: require("@/assets/images/status-icons/step_3_finish.png"),
			errorIcon: require("@/assets/images/status-icons/step_3_error.png")
		},
		{
			title: "测算报告",
			icon: require("@/assets/images/status-icons/step_4.png"),
			activeIcon: require("@/assets/images/status-icons/step_4_active.png"),
			finish: require("@/assets/images/status-icons/step_4_finish.png"),
			errorIcon: require("@/assets/images/status-icons/step_4.png")
		}
	]);

	// 侧边栏
	const visible = ref(true);
	// 事件
	const visibleClick = () => {
		visible.value = !visible.value;
		// 创建一个自定义的 resize 事件
		const resizeEvent = new Event("echartsResize");
		// 触发 resize 事件
		window.dispatchEvent(resizeEvent);
	};

	// 步骤跳转
	const goStep = index => {
		if (Object.keys(store.state.projectInfo).length > 0) {
			const { id, step, shareKey, tfmCapacity, updateFlag, version} =
				store.state.projectInfo;
			if (step >= index + 1) {
				nextTick(() => {
					if (step != 9) {
						clickIndex.value = index;
					}
				});
				// 前往负载分析
				if (index == 0) {
					router.push({
						path: "/load",
						query: {
							id: encryptData(id),
							step: encryptData(1),
							updateFlag: encryptData(updateFlag)
						}
					});
				}
				// 前往配储评估
				if (index == 1) {
					router.push({
						path: "/scheme",
						query: {
							id: encryptData(id),
							tfmCapacity: encryptData(tfmCapacity),
							step: encryptData(2),
							updateFlag: encryptData(updateFlag)
						}
					});
				}
				// 前往经济分析
				if (index == 2) {
					router.push({
						path: "/economic",
						query: {
							id: encryptData(id),
							tfmCapacity: encryptData(tfmCapacity),
							step: encryptData(3),
							updateFlag: encryptData(updateFlag)
						}
					});
				}
				// 前往报告页
				if (index == 3) {
					if (version== "BETA") {
						window.open(
							`${window.location.origin}/report/?shareKey=${shareKey}`,
							"_blank"
						);
					} else {
						window.open(
							`${window.location.origin}/report/v1?shareKey=${shareKey}`,
							"_blank"
						);
					}
				}
			} else {
				console.log("当前项目未到后置步骤！");
			}
		}
	};
</script>

<style lang="less">
	.calculate {
		width: 100%;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		.steps {
			width: 100%;
			height: 40px;
			// padding-left: 27px;
			// padding-right: 55px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin: 12px 0px;
			.step-content {
				width: 65%;
				display: flex;
				justify-content: space-between;
				align-items: center;
				.step {
					position: relative;
					display: flex;
					align-items: center;
					margin-left: 5px;

					&:first-child {
						margin-left: 0;
					}

					.box {
						display: flex;
						align-items: center;
						min-width: 110px;
						cursor: pointer;

						img {
							width: 32px;
							height: 32px;
							margin-right: 4px;
						}

						.active {
							color: #0058fc;
							height: 24px;
							font-family: PingFangSC-Medium;
							font-size: 16px;
							// font-weight: 600;
							color: #0058fc;
							letter-spacing: 0;
							line-height: 24px;
						}

						.errorFont {
							color: #ff0000;
						}
					}
					.font {
						min-width: 100px;
						padding-left: 8px;
						position: absolute;
						bottom: -25px;
						height: 24px;
						font-family: PingFangSC-Medium;
						font-weight: 500;
						font-size: 16px;
						letter-spacing: 0;
						line-height: 24px;
					}

					.active-font {
						color: #0058fc;
					}

					.error-font {
						color: #f40d0d;
					}

					// 基线
					.baseLine {
						flex: 1;
						height: 2px;
						background-color: #a2abbb80;
						display: flex;
						align-items: center;
					}

					// 进度线
					.actionLine {
						border-radius: 5px;
						height: 5px;
						background-color: #0055fb;
					}

					.all {
						flex: 1;
					}

					.half {
						flex: 0.5;
					}

					.error {
						background-color: red;
					}
				}
			}

			button {
				width: 96px;
				height: 40px;
				border-radius: 4px;
			}
		}

		.content {
			width: 100%;
			overflow: auto;
			min-height: calc(100vh - 178px);
			border-radius: 4px;
			display: flex;

			.left {
				height: 100%;
				// max-height:calc(100vh - 178px);
				.side-box {
					width: 356px;
					height: 100%;
					background: #ffffff;
					border: 1px solid #dbe0e8;
					border-radius: 4px 0 0 4px;

					position: relative;

					.side-content {
						max-height: calc(100%);
						overflow-y: auto;
						padding: 24px 24px 14px 24px;

						.bottom-btn {
							height: 44px;
							margin-top: 16px;
						}
					}

					.primary-title {
						height: 28px;
						font-family: PingFangSC-Medium;
						font-weight: 600;
						font-size: 18px;
						color: #000000;
						letter-spacing: 0;
						line-height: 28px;
						margin-bottom: 16px;
                        margin-top: 8px;
						.font {
							display: flex;
							align-items: center;
						}

						&-line {
							width: auto;
							max-width: 80px;
							height: 0;
							border-bottom: 3px solid #0058fc;
							border-left: 3px solid transparent;
							border-right: 3px solid transparent;
							border-radius: 30px;
						}
					}

					.w2 {
						.primary-title-line {
							max-width: 120px;
						}
					}
					.w3 {
						.primary-title-line {
							max-width: 144px;
						}
					}

					.ant-form-item {
						margin-bottom: 16px;
					}
				}
			}
			.right {
				padding: 24px;
				// width: 100%;
				// flex: 1;
				position: relative;
				background: #ffffff;
				margin-left: 8px;
				border: 1px solid #dbe0e8;

				.primary-title {
					height: 28px;
					font-family: PingFangSC-Medium;
					font-weight: 600;
					font-size: 18px;
					color: #000000;
					letter-spacing: 0;
					line-height: 28px;
					// margin-bottom: 16px;
					display: flex;
					justify-content: space-between;
					align-items: center;
					.title-left {
						.font {
							display: flex;
							align-items: center;
							.title-tips {
								height: 22px;
								opacity: 0.65;
								font-family: PingFangSC-Regular;
								font-weight: 400;
								font-size: 14px;
								color: #000000;
								letter-spacing: 0;
								line-height: 22px;
								margin-left: 16px;
							}
						}
						.primary-title-line {
							width: auto;
							max-width: 120px;
							height: 0;
							border-bottom: 3px solid #0058fc;
							border-left: 3px solid transparent;
							border-right: 3px solid transparent;
							border-radius: 30px;
						}
					}
					.title-right {
						height: 40px;
						background: #0cae1c0a;
						border-radius: 4px;
						display: flex;
						align-items: center;
						font-family: PingFangSC-Medium;
						font-weight: 600;
						font-size: 14px;
						letter-spacing: 0;
						line-height: 24px;
						position: relative;

						.left-icon {
							// position: absolute;
							// margin-right: 4px;
							// left: 16px;
							// top: 50%;
							// transform: translateY(-50%);
							cursor: pointer;
							margin-right: 8px;
							img {
								width: 16px;
								height: 16px;
							}
						}

						.right-icon {
							position: absolute;
							// margin-right: 4px;
							right: 12px;
							top: 50%;
							transform: translateY(-50%);
							cursor: pointer;
						}

						.succcess-tips {
							// width: 512px;
							border: 1px solid #0cae1c52;
							color: #0cae1c;
							padding: 8px 37px 8px 16px;

							// .close-icon {
							// 	position: absolute;
							// 	right: 16px;
							// 	cursor: pointer;
							// }
						}
						.doing-tips {
							padding: 8px 37px 8px 40px;
							// width: 279px;
							height: 40px;
							background: #fc610014;
							border: 1px solid #fc61003d;
							border-radius: 4px;
							color: #fc6100;
						}
						.error-tips {
							width: auto;
							background: #f40d0d14;
							border: 1px solid #f40d0d3d;
							border-radius: 4px;
							padding: 8px 50px;
							color: #f40d0d;
						}
					}
				}
			}
		}
	}

	// 公共样式
	.status-img {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		text-align: center;
		img {
			width: 200px;
			height: 200px;
		}

		.info {
			margin-top: 12px;
			&-title {
				height: 28px;
				font-family: PingFangSC-Medium;
				font-weight: 600;
				font-size: 16px;
				color: #000000;
				letter-spacing: 0;
				line-height: 28px;
				text-align: center;
			}

			.second-title {
				opacity: 0.45;
				height: 22px;
				font-family: PingFangSC-Regular;
				font-weight: 400;
				font-size: 14px;
				color: #000000;
				letter-spacing: 0;
				line-height: 22px;
				margin-top: 4px;
				text-align: center;
			}

			.load-title {
				opacity: 0.85;
				height: 22px;
				font-family: PingFangSC-Regular;
				font-weight: 600;
				font-size: 14px;
				color: #000000;
				letter-spacing: 0;
				line-height: 22px;
				margin-top: 4px;
				text-align: center;
			}
		}
	}

	.svga {
		width: 200px;
		height: 200px;
	}

	.tooltip-cion {
		width: 16px;
		height: 16px;
		border-radius: 50%;
		background-color: #b2b2b2;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 10px;
		color: white;
		margin-left: 8px;
        margin-top: 4px;
	}
</style>
